// A tutor's About, Teaching approach and headline are stored as Markdown in plain string
// columns (#1511): tutors paste from ChatGPT, which writes `**bold**` and `- ` lists.
// The long texts are drawn by `BioText`; the headline, and anything that must be one line
// of plain words (search card, booking screen), goes through `plainBioText`.

/** Removes Markdown marks and keeps the words: `**Hi** [a link](address)` -> `Hi a link`. */
export function plainBioText(text: string | null | undefined): string {
  if (!text) return "";
  return text
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/^\s{0,3}#{1,6}\s+/gm, "")
    .replace(/^\s{0,3}>\s?/gm, "")
    .replace(/^\s*(?:[-*+]|\d+[.)])\s+/gm, "")
    .replace(/(\*\*|__)(.+?)\1/g, "$2")
    .replace(/(\*|_)(.+?)\1/g, "$2")
    .replace(/`+([^`]*)`+/g, "$1")
    .replace(/\s*\n+\s*/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();
}

/** What a reader counts: the characters of the words, not the Markdown marks (#1511). */
export function bioTextLength(text: string | null | undefined): number {
  return plainBioText(text).length;
}

/**
 * Markdown the bio editor can load: bold, italics, lists and paragraphs stay; a heading, a
 * quote, a link, an image, code or a rule become plain words. The editor's schema has no node
 * for them, so handing it `### Title` as is would throw (a saved or pasted bio can hold one).
 */
export function bioEditorMarkdown(text: string | null | undefined): string {
  if (!text) return "";
  return text
    .replace(/^\s{0,3}(```|~~~).*$/gm, "")
    .replace(/^\s{0,3}([-*_])(\s*\1){2,}\s*$/gm, "")
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/^\s{0,3}#{1,6}\s+/gm, "")
    .replace(/^\s{0,3}(?:>\s?)+/gm, "")
    .replace(/`+([^`]*)`+/g, "$1")
    .replace(/~~(.+?)~~/g, "$1");
}
